import React, { ChangeEvent } from "react";
import { Box, Select, SelectProps, useColorModeValue } from "@chakra-ui/react";

interface CategorySelectProps extends SelectProps {
  categoria: string;
  onChangeCategoria: (categoria: string) => void;
}

const CategorySelect: React.FC<CategorySelectProps> = ({
  categoria,
  onChangeCategoria,
  ...rest
}) => {
  const textColor = useColorModeValue("black", "black");
  const bgColor = useColorModeValue("white", "white");

  return (
    <Box>
      <Select
        h={10}
        w={40}
        bg={bgColor}
        color={textColor}
        value={categoria}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          onChangeCategoria(e.target.value)
        }
        {...rest}
      >
        <option value="1">1 - Ferragens</option>
        <option value="2">2 - Chaparia</option>
      </Select>
    </Box>
  );
};

export default CategorySelect;
